// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"style_breadcrumbs__BuBeY","current":"style_current__1wq7m","arrow":"style_arrow__3E8gA"};